import React from "react";
import Num2persian from "num2persian";

import {persianArabicToEnglish} from "../../Utils/UnicodeConvert";
import {priceDigitSeperator} from "../../Utils/Helpers";
import "./styles.css";

const Amount = props => {
    const [finalAmount, setFinalAmount] = React.useState(0);
    const [credit, setCredit] = React.useState(0);
    const {amount_of_transaction, eWallets} = props;

    React.useEffect(() => {
        if (Array.isArray(eWallets) && eWallets.length > 0) {
            let wholeCredit = 0;
            eWallets.forEach(item => wholeCredit += parseFloat(item.credit));
            // console.log('wholeCredit', wholeCredit);
            setCredit(wholeCredit);
            if (parseFloat(amount_of_transaction) - wholeCredit < 0) {
                setFinalAmount(0);
            } else {
                setFinalAmount(parseFloat(amount_of_transaction) - Math.floor(wholeCredit));
            };
        } else {
            setFinalAmount(Math.floor(parseFloat(amount_of_transaction)));
            setCredit(0);
        };
    }, [eWallets, amount_of_transaction, credit]);

    if (credit >= parseFloat(amount_of_transaction)) {
        return null;
    };

    return (
        <div className="amount w-100 border border-gray1 rounded p-1 mt-3 d-flex align-items-center justify-content-between">
            <p>مبلغ قابل پرداخت (درگاه بانکی)</p>
            <div className="d-flex flex-column">
                <p className="amount-text">
                    {priceDigitSeperator(finalAmount)} <span className="text-black">تومان</span>
                </p>
                {amount_of_transaction ? (
                    <span className="amount-text">
                        {Num2persian(Math.floor(finalAmount) * 10)} ریال
                    </span>
                ) : null}
            </div>
        </div>
    );
};
export default React.memo(Amount);